import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function Footer() {
  let date = new Date();
  let year = date.getFullYear();
  return (
    <Box className="footer_container">
      <Typography variant="body2">© {year} Alissa Paluska</Typography>
    </Box>
  );
};
